import { Component, OnDestroy, OnInit } from '@angular/core';
import { _ } from '../../shared/utils';
import { LandingPageTile } from '~app/shared/tiles/home-tile.model';
import { SidebarPanelComponent } from '~app/sidebar/sidebar-panel/sidebar-panel.component';
import { AppMessageService } from '~app/shared/app-message/app-message.service';
import { SidebarService } from '~app/shared/sidebar/sidebar.service';
import { AuthService } from '~app/auth/auth.service';

@Component({
  selector: 'qm-measurements-table',
  templateUrl: './measurements-table.component.html',
  styleUrls: []
})
export class MeasurementsTableComponent extends SidebarPanelComponent implements OnInit, OnDestroy {
  public tenant: number;
  protected componentName = MeasurementsTableComponent.getComponentName();

  constructor(protected sidebarService: SidebarService,
              protected appMessageService: AppMessageService,
              private authService: AuthService
              ) {
    super(appMessageService, sidebarService);
    this.tenant = this.authService.getTenant();
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
  }

    /**
   * Configure the `LandingPageTile` for this component
   * @override
   */
  public static initTile(tile: LandingPageTile) {
    tile.description = _('Measurements table');
    tile.icon = 'far fa-tachometer';
    tile.title = _('Measurements table');
    tile.panel = MeasurementsTableComponent.getComponentName();
  }

  /**
   * @returns {string} Name of the component, used for panel and authorization APIs
   */
  private static getComponentName(): string {
    return 'measurements-table';
  }

}
